export const b2bRecurringInvestmentsTranslations = {
  title: 'Versements volontaires récurrents',
  name: 'Versement volontaire récurrent',
  empty: 'Aucun versement volontaire récurrent à afficher',
  list: {
    title: 'Opérations planifiées',
  },
  show: {
    title: 'Détails',
    linked_operations_title: 'Opérations liées',
    linked_operations_empty: "Aucune opération n'a encore été générée",
  },
  create: {
    type: 'Versement volontaire récurrent',
    title: 'Créer un versement volontaire récurrent',
    button: 'Créer',
    type_subtitle: 'Créer un paiement récurrent',
    summary: {
      type: "Type d'opération",
      total_per_occurrence: 'Montant total à payer par occurrence',
      total_mc_per_occurrence: "Montant total d'abondement à payer par occurrence*",
      mc_ceiling: "*Uniquement jusqu'à épuisement du plafond d'abondement du salarié",
    },
    messages: {
      start_date_in_past: 'La date de début ne peut pas être dans le passé',
      no_valid_mandate:
        "L'utilisateur n'a pas de mandat valide. Veuillez vous assurer d'ajouter un mandat valide avant de configurer un versement volontaire récurrent pour cet utilisateur.",
    },
    actions: {
      success: 'Versement volontaire récurrent créé',
      failure: 'Échec de la création du versement volontaire récurrent : %{error}',
    },
  },
  fields: {
    id: 'ID',
    b2b_employee_id: "ID d'employé",
    b2b_contract_id: 'ID Contrat',
    b2b_company_plan_id: 'ID Plan',
    b2b_company_plan_type: 'Équipement',
    status: 'Statut',
    execution_frequency: 'Fréquence',
    user_input_amount: 'Montant',
    user_currency: 'Devise',
    payer: 'Payeur',
    initiator: 'Initiateur',
    deductibility: 'Déductibilité',
    execution_starting_date: 'Date de début',
    next_execution_at: "Prochaine date d'exécution",
    last_executed_at: "Dernière date d'exécution",
    created_at: 'Créé le',
    updated_at: 'Mis à jour le',
  },
  status: {
    active: 'Actif',
    deleted: 'Annulé',
  },
  frequency: {
    weekly: 'Hebdomadaire',
    monthly: 'Mensuelle',
    quarterly: 'Trimestrielle',
    semi_annually: 'Semestrielle',
    yearly: 'Annuelle',
  },
  payer: {
    employee: 'Salarié',
    company: 'Entreprise',
  },
  initiator: {
    user: 'Salarié',
    shares: 'Shares',
    broker: 'Courtier',
    bo: 'Backoffice',
  },
  allocations: {
    title: 'Allocation',
    fields: {
      id: "ID de l'instrument",
      b2b_recurring_investment_id: 'ID Versement récurrent',
      source: 'Source',
      instrument_symbol: 'Symbole',
      instrument_name: 'Nom',
      allocation_percentage: 'Allocation (%)',
      allocation_amount: 'Montant',
      user_currency: 'Devise',
      b2b_fully_managed_allocation_id: 'ID Grille',
      b2b_fully_managed_allocation_template_id: "ID Profil d'investisseur",
      created_at: 'Créé le',
      updated_at: 'Mis à jour le',
    },
    source: {
      allocation: 'Choisi par le salarié',
      managed_grid: 'Grille pilotée',
    },
  },
};
